import { Component, OnInit } from "@angular/core"

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Account, AccountService } from "src/app/services/account.service"
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service";
import { environment } from "src/environments/environment";
import { SetTitleService } from "src/app/services/set-title.service";
import { UserHttpClientService } from "src/app/data/user-http-client.service";
import { User } from "src/app/models/User/user";
@Component({
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.css"]
})

export class AccountComponent implements OnInit {
  accounts: Account[] = []
  editingAccounts: Partial<Account>[] = []
  openingAccountIndexes: number[] = []
  loading: boolean = false
  environment: any
  isAuthorized: boolean

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private accountService: AccountService,
    private converter: LocaleConverterService,
    private settitleservice : SetTitleService,
    private userService: UserHttpClientService
  ) {
    this.environment = environment
  }

  ngOnInit() {
    this.getAccounts();
    this.settitleservice.sendTitle("Accounts");
    this.userService.getUserDetails().subscribe((user: User) => {
      this.isAuthorized = user.is_authorized;
  });
  }

  async getAccounts() {
    if (!this.session.isLoggedIn()) return
    
    this.loading = true
    await this.accountService.getAccounts()
    this.loading = false

    this.accountService.accounts.subscribe(data => this.accounts = data)
  }

  toggleAccount(index: number) {
    if (this.isOpen(index)) {
      this.openingAccountIndexes = this.openingAccountIndexes.filter(number => number !== index)
      return
    }

    this.openingAccountIndexes = this.openingAccountIndexes.concat(index)
  }

  isOpen(index: number) {
    return this.openingAccountIndexes.includes(index)
  }

  onClickEdit(account: Account) {
    const { walletId, accountDescription } = account

    if (this.editingAccounts.map(item => item.walletId).includes(walletId)) {
      this.editingAccounts = this.editingAccounts.filter(item => item.walletId !== walletId)
      return
    }

    this.editingAccounts = this.editingAccounts.concat({ walletId, accountDescription })
  }

  isEdit(account: Account) {
    return this.editingAccounts.map(item => item.walletId).includes(account.walletId)
  }

  getEditingRecord(account: Account) {
    return this.editingAccounts.find(item => item.walletId === account.walletId)
  }

  editData(data: { walletId: number, accountDescription: string }) {
    this.editingAccounts = this.editingAccounts.map(item => {
      if (item.walletId !== data.walletId) {
        return item
      }

      return { ...item, ...data }
    })
  }

  async updateData(account: Account) {
    const editingRecord = this.getEditingRecord(account)
    if (!editingRecord) return

    this.loading = true

    await this.accountService.updateAccount(editingRecord)
    await this.getAccounts()
    this.editingAccounts = this.editingAccounts.filter(item => item.walletId !== account.walletId)

    this.loading = false
  }
}